export * from "/Users/dappweb/Documents/GitHub/Azuro-protocol/example-app/local_modules/wallet/index.ts"